<div class="page page-center">
    <div class="container-tight py-4">
      <div class="empty">
        <div class="empty-header">403</div>
        <p class="empty-title">{{ 'unauthorised.title' | translate }}</p>
        <p class="empty-subtitle text-secondary">
          {{ 'unauthorised.prompt' | translate }}
        </p>
        <div class="empty-action">
          <a href="/" class="btn btn-primary">
            <i class="fa-regular fa-arrow-left me-2"></i>
            {{ 'unauthorised.goBackHome' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>